import { getAppStore } from '~src/app/AppStore';
import { SessionSiteSelectors } from '~src/app/selectors/SessionInfoSelectors';
import { Messages } from '~src/codegen/Localize';
import { IAccelerationTaskInfo } from '~src/dataAcceleration/models/IAccelerationTaskInfo';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { selectSpaceInfo, selectSpaceInfoItem } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';
import { isSiteTasksSpace } from '~src/spacesPlatform/state/SpaceInfo';
import { currentUserIsOwner } from '~src/spacesPlatform/utils/MixedContentHelpers';
import { FeatureFlags } from '~src/ts/FeatureFlags';

import { IViewAcceleration, ViewDataAccelerationState } from '../types/IViewAcceleration';

export function findAccelerationStatusForViewSpace(viewAcceleration: IViewAcceleration): string {
  switch (viewAcceleration.accelerationState) {
  case ViewDataAccelerationState.Failed:
    return Messages.accelerationStatusError();
  case ViewDataAccelerationState.Off:
    return Messages.accelerationStatusDisabled();
  case ViewDataAccelerationState.On:
    return Messages.accelerationStatusEnabled();
  case ViewDataAccelerationState.Pending:
    return Messages.accelerationStatusPending();
  default:
    return Messages.accelerationStatusUnknown();
  }
}

const NUM_SECONDS_PER_MINUTE = 60;

// the following functions are used to find the numbers for the columns whose units may change
export function findLastMonthJobAvgTime(task: IAccelerationTaskInfo): number {
  // lastMonthJobAvgTime needs to be in minutes
  return task.lastMonthJobAvgTimeInSec / NUM_SECONDS_PER_MINUTE;
}

export function findEstimatedDiskUsage(task: IAccelerationTaskInfo): number {
  return task.estimatedDiskUsageKb;
}

export function showAccelerationStatusInViewSubspace(): boolean {
    if (!FeatureFlags.workbookAccelerationUIEnabled) {
        return false;
    }
    const state = getAppStore().getState();
    const spaceInfo = selectSpaceInfo(state);
    if (spaceInfo.subspaceName !== 'views') {
        return false;
    }

    if (getSessionManagementServiceInstance().isSessionSiteOrServerAdmin()) {
        return true;
    }

    return SessionSiteSelectors.canOwnerAccelerate(getAppStore().getState()) &&
        currentUserIsOwner(state, selectSpaceInfoItem(state));
}

export function isDataAccelerationSiteTasksSubspace(spaceInfo: SpaceInfo) {
  return isSiteTasksSpace(spaceInfo) && spaceInfo.subspaceName === 'dataAcceleration';
}
